/**
 * Are we running inside the Android APK rather than a browser?
 *
 * The APK is a thin Capacitor WebView around the live site, so the exact same
 * bundle serves both — without this check the app shows a "Download APK" bar to
 * someone who already installed it.
 *
 * Capacitor injects its bridge into remote `server.url` pages too (both via the
 * DOCUMENT_START_SCRIPT hook and by rewriting the proxied HTML), so
 * `window.Capacitor` is present inside the shell and absent in a plain browser.
 * Deliberately NOT sniffing the generic Android WebView UA marker: that also
 * matches the Instagram/Facebook in-app browsers, which is exactly the traffic
 * the download bar exists for.
 */
type CapacitorGlobal = {
  isNativePlatform?: () => boolean;
  platform?: string;
};

export const isNativeApp = (): boolean => {
  if (typeof window === 'undefined') return false;

  const cap = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
  if (!cap) return false;

  if (typeof cap.isNativePlatform === 'function') return cap.isNativePlatform();
  return !!cap.platform && cap.platform !== 'web';
};
